import * as React from 'react';
import {
    GridComponent, ColumnsDirective, ColumnDirective, Selection, Inject, Toolbar, Edit,
    Filter, Search, ColumnModel, ActionEventArgs, RowSelectEventArgs, EditSettingsModel,
    Page, IFilter, ValueAccessor, CommandColumn, Resize, Reorder, ExcelExport, Sort, SortSettingsModel
} from '@syncfusion/ej2-react-grids';

import { updateSampleSection } from './sample-base';
import '../../node_modules/@syncfusion/ej2-base/styles/bootstrap.css';
import '../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap.css';
import '../../node_modules/@syncfusion/ej2-calendars/styles/bootstrap.css';
import '../../node_modules/@syncfusion/ej2-dropdowns/styles/bootstrap.css';
import '../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap.css';
import '../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap.css';
import '../../node_modules/@syncfusion/ej2-popups/styles/bootstrap.css';
import '../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap.css';
import "../../node_modules/@syncfusion/ej2-react-grids/styles/bootstrap.css";

import { loadCldr } from "@syncfusion/ej2-base";

import * as gregorian from 'cldr-data/main/es-MX/ca-gregorian.json';
import * as numbers from 'cldr-data/main/es-MX/numbers.json';
import * as timeZoneNames from 'cldr-data/main/es-MX/timeZoneNames.json';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
import { setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import { Internationalization } from '@syncfusion/ej2-base';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { API_URL } from '../../Config';

import { IContract, Payment } from '../../models/ContractDetails';

//Load the L10n from ej2-base
import { L10n } from '@syncfusion/ej2-base';
import moment from 'moment';
import { Timestamp } from 'firebase/firestore';
import PaymentService from '../../services/PaymentService';
import ContractService from '../../services/ContractService';
import DebtChargesDialog from './DebtChargesDialog';

setCulture('es-mx');

loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
moment.locale("es-mx");

//load the locale object to set the localized placeholder value
L10n.load({
    'es-MX': {
        'datepicker': {
            today: 'Hoy'
        },
    }
});

type Props = { InitialContracts: IContract[] }


function MasterDetail(this: any, { InitialContracts }: Props) {

    React.useEffect(() => {
        updateSampleSection();
        console.log("RENDER")
    }, []);

    React.useEffect(() => {
        /*console.log("RENDER");
        document.getElementById(paymentsGrid.element.id + "_searchbar").addEventListener('keyup', () => {
            if (paymentsGrid)
            paymentsGrid.search(event.target.value);
        })*/
    });

    const [selectedContractPayments, setSelectedContractPayments] = React.useState<Payment[]>([])
    const [selectedPayment, setSelectedPayment] = React.useState<Payment>();
    const [selectedContract, setSelectedContract] = React.useState<IContract>();
    const [contracts, setContracts] = React.useState<IContract[]>(InitialContracts);
    const [conttractId, setContractId] = React.useState<String>("");

    // State for debt charges dialog
    const [isDebtDialogOpen, setIsDebtDialogOpen] = React.useState<boolean>(false);

    const openLink = (e) => {
        window.open(`${API_URL}/receipt?id=${selectedPayment?.id}&contractId=${selectedContract?.id}`, '_blank', 'noreferrer');
    };

    const commands0: any = [{ buttonOption: { content: "Ver Link", iconCss: ' e-icons e-link', cssClass: 'e-flat', click: openLink.bind(this), } }];

    const commands = [
        {
            buttonOption: {
                content: 'Recibo', cssClass: 'e-flat'
            }
        },

        {
            buttonOption: {
                content: 'Rezago', cssClass: 'e-flat e-money'
            }
        }
    ];
    const commandClick = (args) => {
        if (args.commandColumn.buttonOption.content === 'Recibo') {
            window.open(`${API_URL}/receipt?id=${args.rowData.id}&contractId=${selectedContract?.id}`, '_blank', 'noreferrer');
        } else if (args.commandColumn.buttonOption.content === 'Edit') {
            // Edit the payment record
            if (paymentsGrid) {
                const selectedRow = paymentsGrid.getRowIndexByPrimaryKey(args.rowData.id);
                paymentsGrid.selectRow(selectedRow);
                paymentsGrid.startEdit();
            }
        } else if (args.commandColumn.buttonOption.content === 'Rezago') {
            // Open debt charges dialog
            setSelectedPayment(args.rowData);
            setIsDebtDialogOpen(true);
        }
    };

    const gridTemplate = (props): any => {
        const src = props.EmployeeID + ".png";
        return (<GridComponent
            dataSource={selectedContract?.payments}
            created={created0}
            style={{ flex: "40%" }}
            allowSelection={true}
            ref={grid => paymentsGrid
                = grid}
            height="100%"
            toolbar={toolbarOptions}
            allowFiltering={true}
            filterSettings={{ mode: 'Immediate', immediateModeDelay: 500, type: 'Excel' }}
            editSettings={editSettings}
            actionBegin={actionBeginPaymentsGrid.bind(this)}
            allowPaging={true}
            dataBound={dataBound}
            locale='es-MX'
            searchSettings={searchOptions}
            rowSelected={selectPaymentRow.bind(this)}
            commandClick={commandClick}
            allowResizing={true}
            allowReordering={true}
        >
            <ColumnsDirective>

                <ColumnDirective field='periodDate0' headerText='Periodo' width='90'
                    format='MMM yyyy'
                    type='date'
                    editType="DatePickerEdit"
                    edit={{ params: { allowEdit: false, start: "Year", depth: "Year", locale: 'es-MX', format: 'MMM yyyy' } }}
                />
            </ColumnsDirective>
        </GridComponent>
        )
    }


    const searchOptions = {
        operator: 'contains',
        fields: ['periodDate']
    };

    const toolbarOptions = ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Search', 'ExcelExport',
        { text: 'Reporte', tooltipText: 'Reporte', prefixIcon: 'e-expand', id: 'expandall' }];

    const toolbarClick = async (args) => {
        if (contractsGrid && (args.item.id.includes('grid_') && args.item.id.includes('excelexport'))) {
            contractsGrid.excelExport();
        }

        if (contractsGrid && args.item.id.includes('expandall')) {

            var x: any = [];


            contracts.forEach(c => {
                var newContract: any = {};

                newContract.Manzana = c.block;
                newContract.Lote = c.lot.split(",")[0].padStart(3, "0");
                newContract.Contrato = c.id;
                newContract.Nombre = c.customer.name;
                newContract.Reserva = c.reserve;
                newContract.Tipo = c.type;

                if (c.payments != undefined) {
                    if (c.payments[1] != undefined) {
                        newContract.MedicionAnterior = c.payments[0].currentRead;
                        newContract.FechaMedicionAnterior = c.payments[0].period.toDate();
                    } else {
                        newContract.MedicionAnterior = "";
                        newContract.FechaMedicionAnterior = "";
                    }
                    if (c.payments[0] != undefined) {
                        newContract.MedicionActual = c.payments[1].currentRead;
                        newContract.FechaMedicionActual = c.payments[1].period.toDate();
                    } else {
                        newContract.MedicionActual = "";
                        newContract.FechaMedicionActual = "";
                    }
                }


                if (c.block == "X") {

                } else { x.push(newContract); }

            })

            x.sort(function (a, b) {
                return a.Manzana.localeCompare(b.Manzana) || a.Lote - b.Lote;
            });

            // Create workbook and worksheet using ExcelJS
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');

            // Define columns with headers and widths
            worksheet.columns = [
                { header: 'Manzana', key: 'Manzana', width: 10 },
                { header: 'Lote', key: 'Lote', width: 10 },
                { header: 'Contrato', key: 'Contrato', width: 20 },
                { header: 'Nombre', key: 'Nombre', width: 20 },
                { header: 'Reserva', key: 'Reserva', width: 20 },
                { header: 'Tipo', key: 'Tipo', width: 20 },
                { header: 'MedicionAnterior', key: 'MedicionAnterior', width: 20 },
                { header: 'FechaMedicionAnterior', key: 'FechaMedicionAnterior', width: 20 },
                { header: 'MedicionActual', key: 'MedicionActual', width: 20 },
                { header: 'FechaMedicionActual', key: 'FechaMedicionActual', width: 20 }
            ];

            // Add data rows
            worksheet.addRows(x);

            // Generate and download file
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'ReporteMediciones.xlsx');
        }
    };

    const editSettings: EditSettingsModel = {
        allowEditing: true, allowAdding: true, allowDeleting: true,
        newRowPosition: 'Top', showDeleteConfirmDialog: true, mode: 'Dialog'
    };
    const editparams = { params: { popupHeight: '300px' } };
    const validationRule = { required: true };
    const orderidRules = { required: true, number: true };
    const pageSettings = { pageSize: 20, pageSizes: true };
    const format = { type: 'dateTime', format: 'M/d/y hh:mm a' };

    const key = null;
    const detail: Payment[] = [];
    let paymentsGrid: GridComponent | null;
    let contractsGrid: GridComponent | null;

    function actionBeginContractsGrid(args: ActionEventArgs) {
        if (args.requestType === 'save') {
            if (contractsGrid.pageSettings.currentPage !== 1 && contractsGrid.editSettings.newRowPosition === 'Top') {
                args.index = (contractsGrid.pageSettings.currentPage * contractsGrid.pageSettings.pageSize) - contractsGrid.pageSettings.pageSize;
            }
            else if (contractsGrid.editSettings.newRowPosition === 'Bottom') {
                args.index = (contractsGrid.pageSettings.currentPage * contractsGrid.pageSettings.pageSize) - 1;
            }
            updateContract(args.data as IContract);
        }
        console.log(args.requestType)
    }

    function actionBeginPaymentsGrid(args: ActionEventArgs) {
        if (args.requestType === 'save' && args.data && selectedContract && selectedPayment) {
            if (contractsGrid && contractsGrid.pageSettings && contractsGrid.editSettings) {
                if (contractsGrid.pageSettings.currentPage !== 1 && contractsGrid.editSettings.newRowPosition === 'Top') {
                    const currentPage = contractsGrid.pageSettings.currentPage || 1;
                    const pageSize = contractsGrid.pageSettings.pageSize || 10;
                    args.index = (currentPage * pageSize) - pageSize;
                }
                else if (contractsGrid.editSettings.newRowPosition === 'Bottom') {
                    const currentPage = contractsGrid.pageSettings.currentPage || 1;
                    const pageSize = contractsGrid.pageSettings.pageSize || 10;
                    args.index = (currentPage * pageSize) - 1;
                }
            }

            const paymentData = args.data as any;

            // Keep the existing periodDate logic
            if (paymentData.periodDate0) {
                paymentData.periodDate = moment(paymentData.periodDate0).format("MMM YYYY").replace(".", "");
            }

            // Get the previous payment data for comparison
            if (selectedContract.payments) {
                let pays = [...selectedContract.payments];
                let i = pays.findIndex(c => c.id === selectedPayment.id);

                if (i >= 0) {
                    const oldPayment = pays[i];

                    // Ensure numeric values
                    const previousRead = Number(paymentData.previousRead);
                    const currentRead = Number(paymentData.currentRead);
                    const usage = Number(paymentData.usage);
                    const unitPrice = Number(paymentData.unitPrice);

                    // If L Anterior (previousRead) has been updated
                    if (oldPayment.previousRead !== paymentData.previousRead && paymentData.previousRead !== undefined) {
                        console.log("Previous read updated from", oldPayment.previousRead, "to", previousRead);

                        // Update Consumo based on difference between readings
                        if (paymentData.currentRead !== undefined) {
                            paymentData.usage = currentRead - previousRead;
                            console.log("Usage automatically updated to:", paymentData.usage);
                        }
                    }

                    // If L Actual (currentRead) has been updated
                    if (oldPayment.currentRead !== paymentData.currentRead && paymentData.currentRead !== undefined) {
                        console.log("Current read updated from", oldPayment.currentRead, "to", currentRead);

                        // Update Consumo based on difference between readings
                        if (paymentData.previousRead !== undefined) {
                            paymentData.usage = currentRead - previousRead;
                            console.log("Usage automatically updated to:", paymentData.usage);
                        }
                    }

                    // If usage (consumo) has been updated
                    if (oldPayment.usage !== paymentData.usage && paymentData.usage !== undefined) {
                        console.log("Usage updated from", oldPayment.usage, "to", paymentData.usage);

                        // Update L Actual based on L Anterior + Consumo
                        if (paymentData.previousRead !== undefined) {
                            paymentData.currentRead = previousRead + Number(paymentData.usage);
                        }
                    }

                    // Always update amount based on the latest usage value
                    if (paymentData.unitPrice !== undefined && paymentData.usage !== undefined) {
                        paymentData.amount = Number(paymentData.unitPrice) * Number(paymentData.usage);
                        console.log("Amount updated to:", paymentData.amount);
                    }

                    // Always update totalAmount with any otherCharges
                    let otherChargesTotal = 0;

                    if (paymentData.otherCharges && Array.isArray(paymentData.otherCharges)) {
                        otherChargesTotal = paymentData.otherCharges.reduce((sum: number, charge: any) => {
                            if (typeof charge === 'object' && charge && 'amount' in charge) {
                                return sum + Number(charge.amount);
                            }
                            return sum;
                        }, 0);
                    }

                    // Set totalAmount correctly, ensuring it's a Number type
                    paymentData.totalAmount = Number(paymentData.amount || 0) + otherChargesTotal;

                    // Save the updated payment data
                    pays[i] = paymentData;
                    setSelectedContract({ ...selectedContract, payments: pays });
                    updatePayment(pays[i]);
                }
            }
        } else if (args.requestType === 'delete' && args.data && Array.isArray(args.data) && args.data.length > 0) {
            const p = args.data[0] as Payment;
            console.log("Delete payment:", p.id);
            //PaymentService.deletePayment(p.id, selectedContract?.id);
        }
    }

    function actionCompletePaymentsGrid(args: ActionEventArgs) {
        if (args.requestType === 'save' && args.data && selectedContract && selectedPayment) {
            if (contractsGrid && contractsGrid.pageSettings && contractsGrid.editSettings) {
                if (contractsGrid.pageSettings.currentPage !== 1 && contractsGrid.editSettings.newRowPosition === 'Top') {
                    const currentPage = contractsGrid.pageSettings.currentPage || 1;
                    const pageSize = contractsGrid.pageSettings.pageSize || 10;
                    args.index = (currentPage * pageSize) - pageSize;
                }
                else if (contractsGrid.editSettings.newRowPosition === 'Bottom') {
                    const currentPage = contractsGrid.pageSettings.currentPage || 1;
                    const pageSize = contractsGrid.pageSettings.pageSize || 10;
                    args.index = (currentPage * pageSize) - 1;
                }
            }

            const paymentData = args.data as any;
            if (paymentData.periodDate0) {
                paymentData.periodDate = moment(paymentData.periodDate0).format("MMM YYYY").replace(".", "");
            }

            if (selectedContract.payments) {
                let pays = [...selectedContract.payments];
                let i = pays.findIndex(c => c.id === selectedPayment.id);

                if (i >= 0) {
                    pays[i] = paymentData;
                    setSelectedContract({ ...selectedContract, payments: pays });
                    console.log("Updated payment:", pays[i]);
                }
            }
        } else if (args.requestType === 'delete' && args.data && Array.isArray(args.data) && args.data.length > 0) {
            const p = args.data[0] as Payment;
            console.log("Deleted payment:", p.id);
            // PaymentService.deletePayment(p.id, selectedContract?.id);
        }
    }


    function updatePayment(payment: Payment) {
        //PaymentService.update()
        if (selectedPayment && selectedContract) {
            PaymentService.update(selectedPayment.id, selectedContract.id, payment);
        }
        //console.log(contracts[0].id)
        //const c = contracts;
        //c.find(c => c.id === selectedContract.id).id = "10";
        //setContracts(c)

    }

    // Handler for saving debt charges
    const handleSaveDebtCharges = (updatedPayment: Payment) => {
        if (selectedContract && selectedContract.payments && selectedPayment) {
            // Find the payment index in the contract's payments array
            const paymentIndex = selectedContract.payments.findIndex(p => p.id === updatedPayment.id);

            if (paymentIndex >= 0) {
                // Create a new array of payments with the updated payment
                const updatedPayments = [...selectedContract.payments];
                updatedPayments[paymentIndex] = updatedPayment;

                // Update the selectedContract state with the new payments array
                setSelectedContract({ ...selectedContract, payments: updatedPayments });

                // Update the selected payment
                setSelectedPayment(updatedPayment);

                // Save the updated payment to the database
                updatePayment(updatedPayment);
            }
        }

        // Close the dialog after saving
        setIsDebtDialogOpen(false);
        //selectedPayment.amount = 100;
        //paymentsGrid?.refresh();
        //contractsGrid?.refresh();
    }

    function updateContract(contract: IContract) {
        ContractService.update(contract.id, contract);
    }
    const created = () => {
        document.getElementById(contractsGrid.element.id + "_searchbar").addEventListener('keyup', (event) => {
            contractsGrid.search((event.target as HTMLInputElement).value);
        });
    };
    const created2 = () => {
        document.getElementById(paymentsGrid.element.id + "_searchbar").addEventListener('keyup', (event) => {
            paymentsGrid.search((event.target as HTMLInputElement).value);
        });
    };

    const created0 = () => {

    };

    const created1 = () => {
        console.log("created1");
    };


    function selectContractRow(args: RowSelectEventArgs) {
        console.log("ROW SELECT")
        const selRecord = args.data as IContract;
        if (selRecord) {
            let selecteMessage = document.getElementsByClassName('e-statustext')[0];
            let message = selecteMessage.querySelector('b');
            message.textContent = selRecord.customer.name;
            let payments = selRecord.payments;
            if (payments)
                payments.forEach(c => {
                    if (!c.period) {
                        c.periodDate = (moment().format('MMM YYYY').replace(".", ""));
                        return;
                    }
                    //console.log("id:" + c.id + " period:" + moment(c.period.seconds * 1000));
                    c.periodDate = (moment(c.period.seconds * 1000).format("MMM YYYY").replace(".", ""));
                    c.periodDate0 = new Date(c.period.seconds * 1000);
                    c.due = new Date(c.dueDate.seconds * 1000);
                    c.measurement = new Date(c.measurementDate.seconds * 1000);
                    c.paid = c.paidDate == undefined || c.paidDate == null ? new Date() : new Date(c.paidDate.seconds * 1000);

                    //console.log(moment(c.periodDate, "MMM YYYY").format())
                    //console.log(new Timestamp(+moment(c.periodDate, "MMM YYYY").format("X"), 0));
                })

            //paymentsGrid.dataSource = payments;
            setSelectedContract(selRecord as IContract);
        }
    }

    function selectPaymentRow(args: RowSelectEventArgs) {
        const p: Payment = args.data as Payment;
        //p.measurementDate = args.data?.
        setSelectedPayment(p);
    }

    const customProp = (field: string, data: any, column: ColumnModel) => {
        return data.Prop.SubProp;
    };

    function formatPeriod(field: string, data: Payment, column: ColumnModel): ValueAccessor | string {
        let value = data.period;
        if (value == null || value == undefined) {
            return "";
        }
        return new Date(value.seconds * 1000).toLocaleDateString();
    }

    function formatDate(field: string, data: Payment, column: ColumnModel): ValueAccessor | string {
        let value = data.period;
        if (value == null || value == undefined) {
            return "";
        }
        return new Date(value.seconds * 1000).toLocaleString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })
    }

    const dataBound = () => {
        if (contractsGrid) {
            contractsGrid.autoFitColumns(['Periodo', 'Fecha Pago']);
        }
    };

    function dataBound0() {
        if (contractsGrid) {
            contractsGrid.autoFitColumns(['Periodo', 'Fecha Pago']);
        }
    };

    function getPeriodDate() {
        return (new Date(selectedPayment?.period.seconds * 1000)).toLocaleString('en-US', { month: 'short', year: 'numeric' });
    }

    const getP = () => {
        return new Date(selectedPayment?.period.seconds * 1000).toLocaleString('en-US', { month: 'short', year: 'numeric' });
    }

    const filterPeriod: IFilter = {
        type: 'CheckBox',
        itemTemplate: (e) => {
            if (e.period) {
                let value = e.period;
                //return e.period;
                return <span>{new Date(value.seconds * 1000).toLocaleString('es-MX', { month: 'short', year: 'numeric' })}</span>
            }
        }
    }

    const filterPeriod0: IFilter = {
        type: 'CheckBox',
        itemTemplate: (e) => {
            if (e.period) {
                let value = e.period;
                return <span>{new Date(value.seconds * 1000).toLocaleString('es-MX', { month: 'short', year: 'numeric' })}</span>
            }
        }
    }

    const filterDate: IFilter = {
        type: 'CheckBox',
        itemTemplate: (e) => {
            if (e.period) {
                let value = e.period;
                return <span>{new Date(value.seconds * 1000).toLocaleString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}</span>     // here you can return your customized data 
            }
        }
    }

    const sortingOptions: SortSettingsModel = {
        columns: [{ field: 'block', direction: 'Ascending' }, { field: 'lot', direction: 'Ascending' }]
    };

    return (

        <div className='control-pane' style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden',
            borderWidth: 10,
            borderColor: 'black'
        }}>
            <div className='control-section' style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                overflow: 'hidden',
                gap: '10px'
            }}>
                <div style={{ flex: '0 0 45%', minHeight: 0, overflow: 'hidden' }}>
                    <GridComponent
                        dataSource={contracts}
                        created={created0}
                        rowSelected={selectContractRow.bind(this)}
                        toolbar={toolbarOptions}
                        allowSorting={true}
                        allowMultiSorting={true}
                        allowPaging={true}
                        editSettings={editSettings}
                        pageSettings={pageSettings}
                        actionBegin={actionBeginContractsGrid.bind(this)}
                        ref={grid => contractsGrid = grid}
                        height="100%"
                        allowFiltering={true}
                        filterSettings={{ mode: 'Immediate', immediateModeDelay: 500, type: 'Excel' }}
                        locale='es-MX'
                        allowResizing={true}
                        allowReordering={true}
                        allowExcelExport={true}
                        toolbarClick={toolbarClick}
                        sortSettings={sortingOptions}
                    >
                        <ColumnsDirective>

                            <ColumnDirective field='block' headerText='M' width='20' />
                            <ColumnDirective field='lot' headerText='L' width='20' />
                            <ColumnDirective field='id' headerText='Contrato' width='50' ></ColumnDirective>
                            <ColumnDirective field='meterNumber' headerText='Medidor' width='90'></ColumnDirective>
                            <ColumnDirective field='customer.name' headerText='Nombre' width='170' />
                            <ColumnDirective field='type' headerText='Tipo' width='70' />
                            <ColumnDirective field='reserve' headerText='Reserva' width='70' />
                            <ColumnDirective field='status' headerText='Status' width='70' />


                        </ColumnsDirective>
                        <Inject services={[Selection, Toolbar, Edit, Filter, Search, Page, Resize, Reorder, ExcelExport, Sort]} />
                    </GridComponent>
                </div>

                <div className='e-statustext' style={{ padding: '5px 0' }}> Pagos del cliente:  <b></b></div>

                <div style={{ flex: '1 1 auto', minHeight: 0, overflow: 'hidden' }}>
                    <GridComponent
                        dataSource={selectedContract?.payments}
                        created={created0}
                        allowSelection={true}
                        ref={grid => paymentsGrid
                            = grid}
                        height="100%"
                        toolbar={toolbarOptions}
                        allowFiltering={true}
                        filterSettings={{ mode: 'Immediate', immediateModeDelay: 500, type: 'Excel' }}
                        editSettings={editSettings}
                        actionBegin={actionBeginPaymentsGrid.bind(this)}
                        allowPaging={true}
                        dataBound={dataBound}
                        locale='es-MX'
                        searchSettings={searchOptions}
                        rowSelected={selectPaymentRow.bind(this)}
                        commandClick={commandClick}
                        allowResizing={true}
                        allowReordering={true}
                    >
                        <ColumnsDirective>

                            <ColumnDirective field='periodDate0' headerText='Periodo' width='90'
                                format='MMM yyyy'
                                type='date'
                                editType="DatePickerEdit"
                                edit={{ params: { allowEdit: false, start: "Year", depth: "Year", locale: 'es-MX', format: 'MMM yyyy' } }}
                            />
                            <ColumnDirective field='amount' headerText='Monto' width='110'
                                editType="numericedit"
                                allowEditing={false}
                                edit={{ params: { allowEdit: false, format: 'c2' }, }}
                                format="c2" />
                            <ColumnDirective field='debt' headerText='Adeudo' width='110'
                                editType="numericedit"
                                edit={{ params: { allowEdit: false, format: 'c2' }, }}
                                format="c2" />
                            <ColumnDirective field='otherCharges' headerText='Cargos' width='110'
                                editType="numericedit"
                                edit={{ params: { allowEdit: false, format: 'c2' }, }}
                                format="c2" />
                            <ColumnDirective field='totalAmount' headerText='Total' width='110'
                                editType="numericedit"
                                allowEditing={false}
                                edit={{ params: { allowEdit: false, format: 'c2' }, }}
                                format="c2" />
                            <ColumnDirective field='paid' headerText='Fecha Pago' width='100' type='date'
                                format='dd-MMM-yyyy'
                                editType="DatePickerEdit"
                                edit={{ params: { allowEdit: false, format: 'dd-MMM-yyyy' } }}

                            />
                            <ColumnDirective field='status' headerText='Status' width='110' />
                            <ColumnDirective field='usage' headerText='Consumo' width='100'
                                editType="numericedit"
                                edit={{ params: { format: 'n0' } }}
                                format="n0" />
                            <ColumnDirective field='unitPrice' headerText='Tarifa' width='100'
                                editType="numericedit"
                                edit={{ params: { format: 'n2' } }}
                                format="n2" />
                            <ColumnDirective field='previousRead' headerText='L Anterior' width='110'
                                editType="numericedit"
                                edit={{ params: { format: 'n0' } }}
                                format="n0" />
                            <ColumnDirective field='currentRead' headerText='L Actual' width='110'
                                editType="numericedit"
                                edit={{ params: { format: 'n0' } }}
                                format="n0" />

                            <ColumnDirective field='due' headerText='Vence' width='110'
                                format='dd-MMM-yyyy'
                                editType="DatePickerEdit"
                                edit={{ params: { allowEdit: false, format: 'dd-MMM-yyyy' } }}
                            />
                            <ColumnDirective field='measurement' headerText='Medicion' width='110'
                                format='dd-MMM-yyyy'
                                editType="DatePickerEdit"
                                edit={{ params: { allowEdit: false, format: 'dd-MMM-yyyy' } }}
                            />
                            <ColumnDirective headerText='Actions' width='130' commands={commands} type='command' />
                        </ColumnsDirective>
                        <Inject services={[Selection, Toolbar, Edit, Filter, Page, CommandColumn, Resize, Reorder]} />
                    </GridComponent>
                </div>
            </div>

            {/* Debt Charges Dialog */}
            {selectedPayment && (
                <DebtChargesDialog
                    isOpen={isDebtDialogOpen}
                    onClose={() => setIsDebtDialogOpen(false)}
                    payment={selectedPayment}
                    onSave={handleSaveDebtCharges}
                />
            )}
        </div >);
}
export default MasterDetail;


